module.exports = __webpack_public_path__ + "img/collection-memoireRingsCheap.a05d5af.webp";